import { Component, OnInit } from '@angular/core';
import {ClientinventoryServiceService} from '../../clientinventory-service/clientinventory-service.service';
import {ToastrService} from 'ngx-toastr';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-clientinventory-view',
  templateUrl: './clientinventory-view.component.html',
  styleUrls: ['./clientinventory-view.component.css']
})
export class ClientinventoryViewComponent implements OnInit {

    itemsPerPage = 10;
    currentPage = 1;
    regExp = '';
    status = '';
    clientId: any;
    isClient = true; // If this is false, it means admin has come here through admin page and not required to show

    public noOfClientInventory: any;

    currentUser: any;
    currentUserRole: any = [];
    clientInventoryStatusList: any = [
        { id: '1', value: 'AVAILABLE' },
        { id: '2', value: 'ACTIVATED' },
        { id: '3', value: 'MONITORING' },
        { id: '4', value: 'EXPIRED' },
        { id: '5', value: 'RETURNED' },
        { id: '6', value: 'DAMAGED' }
    ];


  constructor(private clientInventoryService: ClientinventoryServiceService, private modalService: NgbModal,
              private toastr: ToastrService, private _route: ActivatedRoute,
              private _router: Router) {
      this._route.params.subscribe(routeParams => {this.clientId = routeParams.clientIdParam; });
      if (this.clientId !== undefined) {
          this.isClient = false;
      }
      this.clientId = this.clientId !== undefined ? this.clientId : localStorage.getItem('clientId');
  }
    public clientInventoryList: any = [];
    public loading = true;
    public reasonText = '';
    public confirmationCode = '';
    public reasonOption = '';
    public packageHistoryList: any = [];
    public currentPackage: any;
    closeResult: string;

  ngOnInit() {
     this.currentUser = JSON.parse(localStorage.getItem('user'));
     this.currentUserRole = this.currentUser.roles[localStorage.getItem('clientId')];
/*     for (let i = 0; i < this.currentUserRole.length; i++) {
        if (this.currentUserRole[i].indexOf('HOSPITAL_PRIMARY_CONTACT') >= 0) {
            console.log('Enable HPC Permission');
            break;
        } else if (this.currentUserRole[i].indexOf('PHYSICIAN') >= 0 ) {
            console.log('Enable PHY Permission');
            break;
        } else if (this.currentUserRole[i].indexOf('NURSE') >= 0) {
            console.log('Enable NURSE Permission');
            break;
        }
     }*/
     this.getClientInventory(this.status, this.regExp, this.clientId);
  }


    markPackageAvailable(clientInventory) {
        // tslint:disable-next-line:max-line-length
        console.log('Return package: ' + clientInventory.deviceMacId + ', confirmationCode: ' + this.confirmationCode + ', Reason: ' + this.reasonText);
        /*this.clientInventoryService.markPackageAvailable(clientInventory)
            .subscribe(data => {
                this.toastr.success('', 'Package marked available successfully');
                this.loading = false;
                this.getClientInventory();
            }, (error) => {
                this.loading = false;
                this.toastr.error('', 'Please try again');
            });*/
    }

    showPackageHistory(content, clientInventory) {
        this.packageHistoryList = clientInventory.comments;
        this.currentPackage = clientInventory.serialNumber;
        this.modalService.open(content, {size: 'lg', ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    showUpdatePackageConfirmation(markAvailablePackage, clientInventory) {
        this.reasonText = '';
        this.confirmationCode = '';
        this.packageHistoryList = clientInventory.comments;
        this.currentPackage = clientInventory;
        this.modalService.open(markAvailablePackage, {size: 'lg', ariaLabelledBy: 'modal-basic-title2'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;

            if (result === 'SaveMarkAvailableClick') {
                // tslint:disable-next-line:max-line-length
                    console.log('Return package: ' + this.currentPackage.deviceMacId + ', confirmationCode: ' + this.confirmationCode + ', Reason: ' + this.reasonText);
                    const updatePackageRequest = {
                          serialNumber: this.currentPackage.serialNumber,
                          deviceMacId: this.currentPackage.deviceMacId,
                          comment: 'User requested mark package available from WEB',
                          reasonCode: '',
                          reasonText: this.reasonText,
                          confirmationCode: this.confirmationCode
                        };
                    this.clientInventoryService.markPackageAvailable(updatePackageRequest)
                    .subscribe(data => {
                        this.toastr.success('', 'Package marked available successfully');
                        this.loading = false;
                        this.getClientInventory(this.status, this.regExp, this.clientId);
                    }, (error) => {
                        this.loading = false;
                        this.toastr.error('', 'Please try again');
                    });
            }
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }


    showReturnPackageConfirmation(returnPackage, clientInventory) {
        this.reasonText = '';
        this.confirmationCode = '';
        this.reasonOption = '';
        this.packageHistoryList = clientInventory.comments;
        this.currentPackage = clientInventory;
        this.modalService.open(returnPackage, {size: 'lg', ariaLabelledBy: 'modal-basic-title3'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
            if (result === 'SaveReturnClick') {
                // tslint:disable-next-line:max-line-length
                console.log('Return Package initiated: ' + this.currentPackage.deviceMacId + ', Reason: ' + this.reasonOption + ', Description: ' + this.reasonText + ', ConfirmationCode: ' + this.confirmationCode);

                const updatePackageRequest = {
                          serialNumber: this.currentPackage.serialNumber,
                          deviceMacId: this.currentPackage.deviceMacId,
                          comment: 'User requested return to return Package from WEB',
                          reasonCode: this.reasonOption,
                          reasonText: this.reasonText,
                          confirmationCode: this.confirmationCode
                        };


                this.clientInventoryService.returnPackage(updatePackageRequest)
                .subscribe(data => {
                    this.toastr.success('', 'Package Returned Successfully');
                    this.loading = false;
                    this.getClientInventory(this.status, this.regExp, this.clientId);
                }, (error) => {
                    this.loading = false;
                    this.toastr.error('', 'Please try again');
                });
            }


        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }


    private getDismissReason(reason: any): string {

        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return  `with: ${reason}`;
        }
    }

  public getClientInventory(status, regex, clientId) {
    this.loading = true;
    this.clientInventoryService.getClientInventory(this.currentPage - 1, status, this.itemsPerPage, regex, clientId)
        .subscribe(data => {
          const response: any = data.json();
          this.clientInventoryList = response.clientinventory;
          this.noOfClientInventory = response.numberOfClientInventory;
          // console.log(response.clientinventory);

          this.loading = false;
          // TODO - Uncomment below code when using actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

    pageChanged(event) {
        this.currentPage = event;
        this.getClientInventory(this.status, this.regExp, this.clientId);
        console.log(event);
    }

    onChangeStatusFilter(status) {
        console.log(status);
        this.status = status;
        this.getClientInventory(this.status, this.regExp, this.clientId);
    }

    search() {
        console.log('' + this.regExp);
        this.getClientInventory(this.status, this.regExp, this.clientId);
    }



}
